/* eslint-disable consistent-return,default-case,eqeqeq,no-param-reassign,no-plusplus,no-useless-concat,no-var,vars-on-top */

import { COMPONENT_TYPE } from '../../../app/constants/component_type';

xplenty.service('componentFormTagsService', [
  '$timeout',
  '$translate',

  function ($timeout, $translate) {
    return {
      getTags(component) {
        const getValueName = function (key, value) {
          const $label = angular.element(`[for="${key}"]`);
          const $next = $label.next();
          if ($next.is('.btn-group-select')) {
            if (typeof value === 'object') {
              const keys = Object.keys(value);
              if (keys.length > 0) {
                value = $next.find(`[value="${keys[0]}"]`).text();
              }
            } else {
              value = $next.find(`[value="${value}"]`).text();
            }
          } else if ($next.is('xp-select')) {
            value = $next.find('.mat-select-value').text();
          } else if ($next.is('.form-group-options')) {
            value = $next.find('input[type=radio]:checked').next().text();
          }
          return typeof value === 'object' ? '' : value;
        };

        const byString = function (o, s) {
          s = s.replace(/\[(\w+)\]/g, '.$1');
          s = s.replace(/^\./, '');
          const a = s.split('.');
          for (let i = 0, n = a.length; i < n; ++i) {
            const k = a[i];
            if (k in o) {
              o = o[k];
            } else {
              return;
            }
          }
          return o;
        };

        const tags = [];

        const addTag = function (key, label, translationPath) {
          const value = byString(component, key);
          if (translationPath) {
            tags.push({
              name:
                `<span>${_.escape(label)}</span>` + `: <b>${_.escape($translate.instant(translationPath + value))}</b>`,
            });
            return;
          }
          if (component[key] && component[key].length > 0) {
            tags.push({
              name: `<span>${_.escape(label)}</span>` + `: <b>${_.escape(getValueName(key, component[key]))}</b>`,
            });
          } else if (value || value == '') {
            if (value == '') return;
            tags.push({ name: `<span>${_.escape(label)}</span>` + `: <b>${_.escape(getValueName(key, value))}</b>` });
          } else if (label) {
            tags.push({ name: `<b>${_.escape(label)}</b>` });
          }
        };

        switch (component.componentType) {
          case COMPONENT_TYPE.CLOUD_STORAGE_SOURCE_COMPONENT:
            if (['softlayer', 'rackspace', 'swift'].indexOf(component.connection.type) > -1) {
              addTag('bucket', 'Container');
            } else if (['s3', 'gs'].indexOf(component.connection.type) > -1) {
              addTag('bucket', 'Bucket');
            }
            addTag('path', 'Path');
            addTag('record_delimiter', 'Record delimiter');
            addTag('record_type', 'Record type');
            if (component.record_type === 'delimited') {
              addTag('record_settings.field_delimiter', 'Field delimiter');
              addTag('record_settings.text_qualifier', 'String qualifier');
            }
            if (component.record_delimiter === 'eof' && component.record_type === 'json') {
              addTag('json_path', 'Json path');
            }
            if (
              component.connection.type === 's3' ||
              component.connection.type === 'gs' ||
              component.connection.type === 'sftp' ||
              component.connection.type === 'ftps' ||
              component.connection.type === 'azureblobstorage'
            ) {
              addTag('before_action', 'Source action');

              if (component.before_action == 'copy' || component.before_action == 'copy_manifest')
                addTag('char_encoding', 'Character Encoding');
            }
            break;

          case COMPONENT_TYPE.DATABASE_SOURCE_COMPONENT:
            addTag('access_mode', 'Access mode');
            if (component.access_mode === 'table') {
              addTag('schema_name', 'Schema');
              addTag('table_name', 'Table/view');
              addTag('where_clause', 'Where clause');
              addTag('split_by_column_name', 'Split query by key column');
            } else {
              addTag('query', 'Query');
            }
            if (component.split_by_column_name.length > 0) {
              addTag('parallel', 'Max parallel connections');
            }

            addTag('before_action', 'Source action');
            break;

          case COMPONENT_TYPE.AMAZON_REDSHIFT_SOURCE_COMPONENT:
            addTag('access_mode', 'Access mode');
            if (component.access_mode === 'table') {
              addTag('schema_name', 'Schema');
              addTag('table_name', 'Table');
              addTag('where_clause', 'Where clause');
            } else {
              addTag('query', 'Query');
            }
            break;

          case COMPONENT_TYPE.SPANNER_SOURCE_COMPONENT:
          case COMPONENT_TYPE.BIG_QUERY_SOURCE_COMPONENT:
            addTag('access_mode', 'Access mode');
            if (component.access_mode === 'table') {
              addTag('table_name', 'Table');
            } else {
              addTag('query', 'Query');
            }
            break;
          case COMPONENT_TYPE.NET_SUITE_SOURCE_COMPONENT:
            addTag('table_name', 'Table');
            break;
          case COMPONENT_TYPE.MONGO_SOURCE_COMPONENT:
            addTag('table_name', 'Source collection');
            addTag('where_clause', 'Filter query');
            break;

          case COMPONENT_TYPE.CLOUD_STORAGE_DESTINATION_COMPONENT:
            if (['s3', 'gs'].indexOf(component.connection.type) > -1) {
              addTag('bucket', 'Bucket');
            }
            addTag('path', 'Directory');
            addTag('file_names', 'File pattern');

            if (component.operation_type == 'copy_files') addTag('char_encoding', 'Character Encoding');

            break;

          case COMPONENT_TYPE.BING_ADS_SOURCE_COMPONENT:
            addTag('api_version', 'API version');
            addTag('report_type', 'Report type');
            addTag('report_aggregation_type', 'Unit of time');
            addTag('report_date_range_type', 'Date range');
            addTag('report_on', 'Report on');
            break;

          case COMPONENT_TYPE.ANALYTICS_SOURCE_COMPONENT:
            addTag('report_on', 'Report on');
            addTag('report_date_range_type', 'Date Range');

            if (component.report_date_range_type === 'CUSTOM_DATE') {
              addTag('report_date_range_min', 'From date');
              addTag('report_date_range_max', 'To date');
            }
            break;
          case COMPONENT_TYPE.ADWORDS_SOURCE_COMPONENT:
            addTag('report_type', 'Report type');
            addTag('report_date_range_type', 'Date Range');

            if (component.report_date_range_type === 'CUSTOM_DATE') {
              addTag('report_date_range_min', 'From date');
              addTag('report_date_range_max', 'To date');
            }
            addTag('customer_ids', 'Customer ids');
            break;
          case COMPONENT_TYPE.SALESFORCE_SOURCE_COMPONENT:
            addTag('access_mode', 'Access mode');
            if (component.access_mode === 'object') {
              addTag('object_name', 'Object');
            } else {
              addTag('query', 'Query');
            }

            break;
          case COMPONENT_TYPE.SALESFORCE_DESTINATION_COMPONENT:
            addTag('object_name', 'Object');
            addTag('operation_type', 'Operation');

            break;

          case COMPONENT_TYPE.SALESFORCE_SOAP_DESTINATION_COMPONENT:
            addTag('object_name', 'Object');
            addTag('operation_type', 'Operation');

            break;

          case COMPONENT_TYPE.NETSUITE_SOAP_DESTINATION_COMPONENT:
            addTag('object_name', 'Object');
            addTag('operation_type', 'Operation');

            break;

          case COMPONENT_TYPE.FACEBOOK_ADS_DESTINATION_COMPONENT:
          case COMPONENT_TYPE.TIKTOK_ADS_DESTINATION_COMPONENT:
            addTag('object_name', 'Object');
            addTag('operation_type', 'Operation');

            break;

          case COMPONENT_TYPE.FACEBOOK_ADS_INSIGHTS_SOURCE_COMPONENT:
            var accountsText;

            if (component.report_on === 'all') {
              accountsText = 'all accounts';
            } else {
              accountsText = `${
                component.ad_accounts.length + (component.ad_accounts.length === 1 ? ' account' : ' accounts')
              } selected`;
            }

            tags.push({ name: `${'<span>Ad accounts</span>' + ': <b>'}${accountsText}</b>` });

            addTag('level', 'Level');
            addTag('report_date_range_type', 'Date Range');

            if (component.report_date_range_type === 'CUSTOM_DATE') {
              addTag('report_date_range_min', 'From date');
              addTag('report_date_range_max', 'To date');
            }

            break;
          case COMPONENT_TYPE.REST_API_SOURCE_COMPONENT:
            addTag('method', 'Method');
            if (component.url && component.url.length > 0) {
              addTag('url', 'URL');
            }
            if (component.use_pagination) {
              addTag('', 'Use pagination');
            }
            addTag('response_type', 'Response type', 'rest-api-source-editor.form.selects.response_type.options.');
            break;

          case COMPONENT_TYPE.JOIN_COMPONENT:
            addTag('join_type', 'Type');
            addTag('optimization_type', 'Optimization');
            break;

          case COMPONENT_TYPE.SNOWFLAKE_DESTINATION_COMPONENT:
          case COMPONENT_TYPE.AMAZON_REDSHIFT_DESTINATION_COMPONENT:
          case COMPONENT_TYPE.DATABASE_DESTINATION_COMPONENT:
          case COMPONENT_TYPE.BIG_QUERY_DESTINATION_COMPONENT:
          case COMPONENT_TYPE.SPANNER_DESTINATION_COMPONENT:
            if (component.warehouse && component.warehouse.length > 0) {
              addTag('warehouse', 'Warehouse');
            }
            if (component.database && component.database.length > 0) {
              addTag('database', 'Database');
            }
            if (component.schema_name && component.schema_name.length > 0) {
              addTag('schema_name', 'Schema');
            }
            addTag('table_name', 'Table');
            addTag('operation_type', 'Operation');
            break;
          case COMPONENT_TYPE.MONGO_DESTINATION_COMPONENT:
            addTag('table_name', 'Collection');
            addTag('operation_type', 'Operation');
            break;
        }

        if (
          component.componentType === COMPONENT_TYPE.BIG_QUERY_SOURCE_COMPONENT &&
          component.access_mode === 'query'
        ) {
          addTag('use_legacy_sql', 'Use Legacy SQL');
          addTag('stored_procedure', 'Stored Procedure Query');
        }

        if (
          (component.componentType === COMPONENT_TYPE.SPANNER_SOURCE_COMPONENT ||
            component.componentType === COMPONENT_TYPE.NET_SUITE_SOURCE_COMPONENT) &&
          component.access_mode === 'table'
        ) {
          addTag('where_clause', 'Where clause');
        }

        return tags;
      },
    };
  },
]);
